<template>
  <div class="p-4">
    <div class="state-menu col-md-12 d-flex justify-content-between mb-2">
      <h2>
        {{
          activeState == "All" ? $t("message.all") : activeState | Capitalize
        }}
        {{ headline }}
      </h2>
      <nav
        v-if="allowedState.length > 2"
        class="navbar navbar-expand navbar-light bg-light state-menu"
        :style="getNavbarStyles()"
      >
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarTogglerDemo01"
          aria-controls="navbarTogglerDemo01"
          aria-expanded="false"
          aria-label="Toggle navigation"
        ></button>
        <div class="collapse navbar-collapse" id="navbarTogglerDemo01">
          <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
            <li class="nav-item" v-for="st in this.allowedState" :key="st">
              <a
                class="nav-link"
                :class="{ active: activeState === st }"
                :style="getStateSelectionRolldStyles(activeState === st)"
                @click.prevent="filterStore(st)"
                href="#"
                >{{ st == "All" ? $t("message.all") : st }}</a
              >
            </li>
          </ul>
        </div>
      </nav>
    </div>
    <div v-if="show" style="width: 100%" class="row mt-4">
      <div
        v-for="(rs, index) in orderedResturants"
        :key="rs.ID"
        class="col-md-3"
        :class="{
          rolld: isRolldStore(),
          'mb-4': !isRolldStore(),
        }"
        :style="getRestaurantBorderStyle(index + 1)"
      >
        <i v-if="isRolldStore()" class="location-icon"
          ><img src="../../../assets/location-icon.png"
        /></i>
        <div class="rs-item">
          <div class="badge" v-if="storeClosed(rs)">
            {{ $t("message.closed") }}
          </div>
          <a @click="navigateToStore(rs)">
            <div
              v-if="!isRolldStore() && rs.ProfileImage"
              :style="{ 'background-image': 'url(' + rs.ProfileImage + ')' }"
              class="w-100 rs-img-item"
            >
              <span v-if="pos" class="fs-90">
                <i class="material-icons">near_me</i>
                {{ distance(rs.Location.Latitude, rs.Location.Longitude) }}km
                {{ $t("message.away") }}
              </span>
            </div>
            <span class="d-block mt-2 font-weight-bold store-name">{{
              rs.Name
            }}</span>
            <div v-if="rs.StoreTitle" class="store-title">
              {{ rs.StoreTitle }}
            </div>
            <div
              v-if="getOperatingHours(rs)"
              class="fs-80 store-address"
              :class="{ 'color-gray': !isRolldStore() }"
            >
              {{ rs.Location.Address }}
              <br />
              {{ rs.Location.Suburb }} {{ rs.Location.State }}
              {{ rs.Location.Postcode }}
              <br />
              <span v-if="rs.OfficePhone">PH: {{ rs.OfficePhone }}</span>
            </div>
            <div
              v-if="getOperatingHours(rs)"
              class="fs-80 store-hours"
              :class="{ 'color-gray': !isRolldStore() }"
            >
              <span style="font-weight: 600" v-if="isRolldStore()"
                >Opening Hours</span
              >
              <br />
              {{ $t("message.open") }}
              <span>{{ getOperatingHours(rs).openTime }}</span>
              {{ $t("message.toName") }}
              <span>{{ getOperatingHours(rs).closeTime }}</span>
            </div>
            <div class="order-now" v-if="isRolldStore()">
              <img src="../../../assets/order-now.png" />
            </div>
          </a>
        </div>
      </div>
    </div>
    <div v-else>
      <message :message="getNoStoreAvailableInDatabaseLang" v-show="!busy" />
      <progressindicator v-show="busy" style="opacity: 0.4"></progressindicator>
    </div>
  </div>
</template>

<script>
import shared from "../../../sharedscripts/master/Resturant/ResturantsFilter.js";
import Progressindicator from "../../progressindicator";
import Message from "../../shared/Message";
export default {
  components: {
    Progressindicator,
    Message,
  },
  filters: {
    ...shared.filters,
  },
  props: {
    activeState: {
      type: String,
      default: "All",
    },
  },
  data() {
    return {
      populars: [],
      pos: null,
      busy: false,
      states: ["All", "ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA"],
    };
  },
  computed: {
    ...shared.computed,
  },
  created() {
    this.checkLocation();
  },
  mounted() {
    this.getStores();
  },
  methods: {
    ...shared.methods,
    getStateSelectionRolldStyles(isSelected) {
      var styles = [];
      if (this.isRolldStore()) {
        if (isSelected) styles.push(this.desktopStyles.MenuHighlightedText);
        else styles.push(this.desktopStyles.textColour);
      }
      return styles;
    },
  },
};
</script>
